[
  {
    "id": "MET-B8P-L302-001",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een kubus heeft een inhoud van 27 m³. Wat is de lengte van een zijde?",
    "options": ["3 m", "9 m", "6 m", "2 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KUBUS-ZIJDE",
    "explanation": "Zijde × zijde × zijde = 27. 3 × 3 × 3 = 27. Dus de zijde is 3 m.",
    "distractorExplanations": {
      "1": "9 × 9 × 9 = 729. Veel te groot.",
      "2": "6 × 6 × 6 = 216. Te groot.",
      "3": "2 × 2 × 2 = 8. Te klein."
    }
  },
  {
    "id": "MET-B8P-L302-002",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Reken om: 54 km/u = ... m/s",
    "options": ["15 m/s", "20 m/s", "10 m/s", "18 m/s"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS",
    "explanation": "Van km/u naar m/s is delen door 3,6. 54 : 3,6 = 15 m/s.",
    "distractorExplanations": {
      "1": "Schattingsfout.",
      "2": "36 : 3,6 = 10.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "MET-B8P-L302-003",
    "module": "Metriek",
    "difficulty": 302,
    "question": "De oppervlakte van een cirkel is 314 cm². Wat is de straal ongeveer? (π = 3,14)",
    "options": ["10 cm", "100 cm", "50 cm", "20 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-CIRKEL-STRAAL",
    "explanation": "Oppervlakte = π × r². 314 = 3,14 × r². r² = 100. r = 10 cm.",
    "distractorExplanations": {
      "1": "Dat is r² (het kwadraat van de straal).",
      "2": "Dat is de helft van r².",
      "3": "Dat is de diameter (2 × straal)."
    }
  },
  {
    "id": "MET-B8P-L302-004",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Hoeveel weegt een blok lood van 10 bij 10 bij 10 cm? (Soortelijk gewicht = 11 kg/dm³)",
    "options": ["11 kg", "1,1 kg", "110 kg", "1.100 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-LOOD",
    "explanation": "10 × 10 × 10 cm = 1.000 cm³ = 1 dm³. 1 dm³ lood weegt 11 kg.",
    "distractorExplanations": {
      "1": "Dat is 0,1 dm³.",
      "2": "Dat is 10 dm³.",
      "3": "Dat is 100 dm³."
    }
  },
  {
    "id": "MET-B8P-L302-005",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Reken om: 0,0005 km = ... cm",
    "options": ["50 cm", "5 cm", "500 cm", "0,5 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-KM-CM-KLEIN",
    "explanation": "Van km naar cm is 5 stappen (×100.000). 0,0005 × 100.000 = 50 cm.",
    "distractorExplanations": {
      "1": "Een nul te weinig.",
      "2": "Een nul te veel.",
      "3": "Twee nullen te weinig."
    }
  },
  {
    "id": "MET-B8P-L302-006",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een zwembad is 25 m lang, 12 m breed en 1,8 m diep. Hoeveel kubieke meter water past erin?",
    "options": ["540 m³", "450 m³", "300 m³", "5.400 m³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-ZWEMBAD-B8P",
    "explanation": "Inhoud = 25 × 12 × 1,8 = 540 m³.",
    "distractorExplanations": {
      "1": "Je deed 25 × 12 × 1,5.",
      "2": "Je deed 25 × 12 en vergat de diepte.",
      "3": "Je deed 540 × 10."
    }
  },
  {
    "id": "MET-B8P-L302-007",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een kubus heeft zijden van 8 cm. Wat is de inhoud in liters?",
    "options": ["0,512 liter", "5,12 liter", "51,2 liter", "512 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KUBUS-LITER",
    "explanation": "Inhoud = 8 × 8 × 8 = 512 cm³. 512 : 1.000 = 0,512 liter.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.",
      "3": "Je vergat te delen."
    }
  },
  {
    "id": "MET-B8P-L302-008",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Reken om: 72 km/u = ... m/s",
    "options": ["20 m/s", "72 m/s", "7,2 m/s", "200 m/s"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS-72",
    "explanation": "Van km/u naar m/s: delen door 3,6. 72 : 3,6 = 20 m/s.",
    "distractorExplanations": {
      "1": "Dat is de snelheid in km/u.",
      "2": "Je deelde door 10.",
      "3": "Je vermenigvuldigde met 3,6."
    }
  },
  {
    "id": "MET-B8P-L302-009",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een bak water van 0,5 m³ weegt 500 kg. Hoeveel weegt 1 liter water?",
    "options": ["1 kg", "0,5 kg", "2 kg", "10 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-WATER-1L",
    "explanation": "0,5 m³ = 500 liter. 500 kg : 500 liter = 1 kg per liter.",
    "distractorExplanations": {
      "1": "Je deelde 500 door 1.000.",
      "2": "Je deelde 500 door 250.",
      "3": "Je deelde 500 door 50."
    }
  },
  {
    "id": "MET-B8P-L302-010",
    "module": "Metriek",
    "difficulty": 302,
    "question": "De omtrek van een cirkel is 62,8 cm. Wat is de diameter? (π = 3,14)",
    "options": ["20 cm", "10 cm", "31,4 cm", "40 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-CIRKEL-TERUG",
    "explanation": "Omtrek = π × diameter. 62,8 = 3,14 × d. d = 62,8 : 3,14 = 20 cm.",
    "distractorExplanations": {
      "1": "Dat is de straal (diameter : 2).",
      "2": "Dat is de halve omtrek.",
      "3": "Je deed 62,8 × 2."
    }
  },
  {
    "id": "MET-B8P-L302-011",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Reken om: 0,004 m³ = ... ml",
    "options": ["4.000 ml", "400 ml", "40 ml", "40.000 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-ML-B8P",
    "explanation": "0,004 m³ = 4 liter = 4.000 ml.",
    "distractorExplanations": {
      "1": "Je deed 4 × 100.",
      "2": "Je deed 4 × 10.",
      "3": "Je deed 4 × 10.000."
    }
  },
  {
    "id": "MET-B8P-L302-012",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een ijzeren blok is 20 cm × 10 cm × 5 cm. IJzer weegt 7,8 kg per dm³. Hoeveel weegt het blok?",
    "options": ["7,8 kg", "78 kg", "0,78 kg", "15,6 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-IJZER",
    "explanation": "Inhoud: 20 × 10 × 5 = 1.000 cm³ = 1 dm³. 1 dm³ × 7,8 = 7,8 kg.",
    "distractorExplanations": {
      "1": "Dat is 10 dm³.",
      "2": "Dat is 0,1 dm³.",
      "3": "Dat is 2 dm³."
    }
  },
  {
    "id": "MET-B8P-L302-013",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een vrachtwagen rijdt 90 km/u. Hoeveel km legt hij af in 40 minuten?",
    "options": ["60 km", "36 km", "90 km", "45 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-SNELHEID-40MIN",
    "explanation": "40 minuten = $\\frac{2}{3}$ uur. $\\frac{2}{3}$ × 90 = 60 km.",
    "distractorExplanations": {
      "1": "Je deed 40 : 100 × 90.",
      "2": "Dat is in 1 uur.",
      "3": "Dat is in 30 minuten."
    }
  },
  {
    "id": "MET-B8P-L302-014",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Reken om: 1,5 hl = ... dl",
    "options": ["1.500 dl", "150 dl", "15 dl", "15.000 dl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-HL-DL-B8P",
    "explanation": "1 hl = 100 liter = 1.000 dl. 1,5 × 1.000 = 1.500 dl.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-B8P-L302-015",
    "module": "Metriek",
    "difficulty": 302,
    "question": "Een kubus heeft een inhoud van 8 dm³. Wat is de lengte van een zijde?",
    "options": ["2 dm", "4 dm", "8 dm", "1 dm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KUBUS-ZIJDE-2",
    "explanation": "Zijde × zijde × zijde = 8. 2 × 2 × 2 = 8. Dus de zijde is 2 dm.",
    "distractorExplanations": {
      "1": "4 × 4 × 4 = 64. Te groot.",
      "2": "8 × 8 × 8 = 512. Veel te groot.",
      "3": "1 × 1 × 1 = 1. Te klein."
    }
  }
]